import React from 'react'
import { TransProps } from '@lingui/react'
import {getColor} from 'components/utils'


// Type
export type typeButton = {
    variant?: string
    secondary?: boolean
    id?: string
    name?: string
    type: "submit" | "button"
    label?: React.ReactElement<TransProps>
    icon?: React.ReactElement<(props: React.ComponentProps<"svg">) => JSX.Element>
    disabled?: boolean
    buttonClassName?: string

    onClick?: (e: React.MouseEvent | React.TouchEvent) => void
}


// Component
export const Button:React.FC<typeButton> = ({
    variant,
    secondary,
    id,
    name,
    type,
    label,
    icon,
    disabled=false,
    buttonClassName,

    onClick
}) => {

    const color = getColor(variant)
    let buttonStyles

    if (secondary) {
        buttonStyles = [`flex justify-center items-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${disabled ? 'bg-gray-100' : 'bg-white'} border border-gray-300 ${disabled ? 'text-gray-500 cursor-not-allowed' : 'text-gray-700'} hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${color}-500`, buttonClassName].join(' ')
    } else {
        buttonStyles = [`flex justify-center items-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${disabled ? 'bg-gray-400 cursor-not-allowed' : `bg-${color}-800 hover:bg-${color}-900`} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${color}-500`, buttonClassName].join(' ')
    }

    return(
        <button
            id={id}
            name={name}
            type={type}
            disabled={disabled}
            onClick={onClick}
            className={buttonStyles}
        >
            {icon}
            {label}
        </button>
    )
}
